'use client';

import React from 'react';
import { useTranslations } from 'next-intl';
import { TrustpilotCompactRating } from '@/ui/components/tiles/trustpilot-widget/trustpilot-compact-rating';

/**
 * Reserved row above the product title for the review rating. The compact
 * Trustpilot rating renders nothing until a rating is available, so the slot
 * collapses instead of leaving an empty band behind.
 */
export function ReviewRatingSlot() {
  const t = useTranslations('ClassicProductDetail');

  return (
    <section aria-label={t('customerReviews')} className="flex justify-start">
      <TrustpilotCompactRating />
    </section>
  );
}
